import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'types';
import Filter from './filter';
import './top.scss';

function Top() {
    const project = useSelector((state: RootState) => state.project);
    const [filterOpen, setFilterOpen] = useState(false);
    const filterRef = useRef<any>();

    const toggleFilter = () => {
        setFilterOpen(!filterOpen);
    }

    return (
        <div className="top">
            <p className="project-name">{project.Description}</p>
            <p className="project-type">{project.ProjectType}</p>
            <span className='filters' ref={filterRef} onClick={toggleFilter}>Filter<i className={`fal ${filterOpen ? 'fa-times' : 'fa-sliders-h'}`}></i></span>
            <Filter 
                open={filterOpen}
                setOpen={setFilterOpen}
                buttonRef={filterRef}
            />
            {/* <FiltersMenu 
                open={filtersOpen}
                setOpen={setFiltersOpen}
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
                streamIds={streamIds}
                setStreamIds={setStreamIds}
                projectTypeId={project?.ProjectTypeId}
                showDatePicker={true}
                buttonRef={filtersMenuRef}
                dateRangeComparison={onDateRangeComparison}
            /> */}
        </div>
    )
}

export default Top;